document.addEventListener('DOMContentLoaded', function () {
  const read = document.querySelector('.read');
  const productDescriptionFull = document.querySelector('.product-description-full');

  if (!read || !productDescriptionFull) {
    return;
  }

  read.addEventListener('click', function () {
    if (productDescriptionFull.classList.contains('open')) {
      productDescriptionFull.classList.remove('open');
      read.textContent = window.themeVariables.strings.readMore;
    } else {
      productDescriptionFull.classList.add('open');
      read.textContent = window.themeVariables.strings.readLess;
    }
  });
});
